module.exports = __webpack_public_path__ + "static/img/wd2.3036dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workimg/wd2.png
// module id = Ojjv
// module chunks = 10